const state = {
  quesData: null,
  thingsActive: 0
}

const mutations = {
  changeQuesData: (state, obj) => {
    state.quesData = obj;
  },
  changeThingsActive: (state, v) => {
    console.log(v, '----')
    state.thingsActive = v;
  }
}

const actions = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/competitionOnline.js